module.exports = __webpack_public_path__ + "img/winebg.73c0b870.jpg";